import { Routes } from "@angular/router";
import { HeroComponent } from "./components/hero/hero.component";
import { AboutComponent } from "./components/about/about.component";
import { ClassesComponent } from "./components/classes/classes.component";
import { ProductsComponent } from "./components/products/products.component";
import { GalleryComponent } from "./components/gallery/gallery.component";
import { TrainersComponent } from "./components/trainers/trainers.component";
import { ContactComponent } from "./components/contact/contact.component";

export const routes: Routes = [
  { path: "", component: HeroComponent },
  { path: "about", component: AboutComponent },
  { path: "classes", component: ClassesComponent },
  { path: "products", component: ProductsComponent },
  { path: "gallery", component: GalleryComponent },
  { path: "trainers", component: TrainersComponent },
  { path: "contact", component: ContactComponent },
  { path: "**", redirectTo: "" }
];

